import axiosInstance from '@/services/axiosInstance'

async function altaVerifactuPortal (files, params = null) {
  try {
    if (process.env.VUE_APP_ENVIRONMENT === 'test') {
      return new Promise((resolve, reject) => {
        resolve()
      })
    } else {
      const formData = new FormData()
      files.forEach(file => {
        // console.log('CustomLog: file', file)
        formData.append(encodeURIComponent(file.linkid), file.raw)
        
        // formData.append('file', file.raw)
      })
      
      const req = {
        url: 'api/verifactu/altaVerifactuPortal',
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data'
        },
        params,
        data: formData,
        timeout: 300000,
      }
      const res = await axiosInstance(req)
      return res.data
    }
  } catch (error) {
    return { blnError: true, msgError: error.message, codError: 'AXI002', Respuestas: null }
  }
}

export { altaVerifactuPortal }
